import { FilespaceLineItem, FilespaceUsage } from 'fs-api-client';
import * as React from 'react';
import { formatDataSize } from 'src/webportal/utils/utilFunctions';

const dimensionEnums = FilespaceUsage.DimensionEnum;
const GIB_MULTIPLIER = 1024 * 1024 * 1024;

const DIMENSION_HEADERS = [
    dimensionEnums.Capacity,
    dimensionEnums.ConnectedDevices,
    dimensionEnums.FilespaceDays,
    dimensionEnums.ManagedCapacity,
    dimensionEnums.Storage,
    dimensionEnums.Egress,
    dimensionEnums.FilespaceUsers
];
const DIMENSION_WEIGHT = {
    [dimensionEnums.Storage]: 1,
    [dimensionEnums.Capacity]: 2,
    [dimensionEnums.ManagedCapacity]: 3,
    [dimensionEnums.Egress]: 4,
    [dimensionEnums.ConnectedDevices]: 5,
    [dimensionEnums.FilespaceDays]: 6,
    [dimensionEnums.FilespaceUsers]: 7
};

const DIMENSION_DESCRIPTION_MAP = {
    [dimensionEnums.Capacity]: 'Capacity Used',
    [dimensionEnums.ManagedCapacity]: 'Capacity-to-date',
    [dimensionEnums.Storage]: 'LucidLink Storage',
    [dimensionEnums.Egress]: 'Egress-to-date',
    [dimensionEnums.ConnectedDevices]: 'Connected Devices',
    [dimensionEnums.FilespaceDays]: 'Filespace Days',
    [dimensionEnums.FilespaceUsers]: 'Users-to-date'
};
const DIMENSION_USAGE_SUFFIXES = {
    [dimensionEnums.Capacity]: 'GB',
    [dimensionEnums.ManagedCapacity]: 'GB',
    [dimensionEnums.Storage]: 'GB',
    [dimensionEnums.Egress]: 'GB',
    [dimensionEnums.ConnectedDevices]: 'devices',
    [dimensionEnums.FilespaceDays]: 'days',
    [dimensionEnums.FilespaceUsers]: 'users'
};

export interface FilespaceBreakdownBaseProperties {
}

abstract class FilespaceBreakdownBase<P extends FilespaceBreakdownBaseProperties, S> extends React.Component<P, S> {
    getTableHeaders(lineItems: FilespaceLineItem[]| undefined): any[] {
        if (!lineItems) {
            return [];
        }
        let result = new Set();
        for (const lineItem of lineItems) {
            const fsUsage = lineItem.usageByDimension;
            for (const usage of fsUsage) {
                if (!DIMENSION_HEADERS.includes(usage.dimension)) {
                    continue;
                }
                result.add(usage.dimension);
            }
        }
        return Array.from(result).sort((el1: string, el2: string) => DIMENSION_WEIGHT[el1] - DIMENSION_WEIGHT[el2]);
    }

    getDescriptionForDimension(dimension: FilespaceUsage.DimensionEnum) {
        return DIMENSION_DESCRIPTION_MAP[dimension];
    }

    getDescriptionUsageSuffix(dimension: FilespaceUsage.DimensionEnum) {
        return DIMENSION_USAGE_SUFFIXES[dimension];
    }

    renderStorageType (filespaceLineItem: FilespaceLineItem) {
        const planBasedStrings = {
            LucidLinkBasic: filespaceLineItem.subscriptionType === FilespaceLineItem.SubscriptionTypeEnum.Basic ?
                'LucidLink Basic' :
                'LucidLink Standard',
            LucidLinkTeams: 'LucidLink Teams',
            LucidLinkEnterprise: 'LucidLink Enterprise',
            LucidLinkCustom: 'LucidLink Custom',
            LucidLinkPerformance: 'LucidLink Performance',
            LucidLinkAdvanced: 'LucidLink Advanced',
        };
        if (filespaceLineItem.storageOwner === FilespaceLineItem.StorageOwnerEnum.Customer) {
            return (<td className="hidden left">{planBasedStrings.LucidLinkCustom}</td>);
        } else {
            if (filespaceLineItem.storageProvider === 'Wasabi') {
               return (<td className="hidden left">{planBasedStrings.LucidLinkBasic}</td>);
            } else if (filespaceLineItem.storageProvider === 'AWS') {
                if (filespaceLineItem.subscriptionType === FilespaceLineItem.SubscriptionTypeEnum.Advanced) {
                    return (<td className="hidden left">{planBasedStrings.LucidLinkAdvanced}</td>);
                } else {
                    return (<td className="hidden left">{planBasedStrings.LucidLinkPerformance}</td>);
                }
            } else if (filespaceLineItem.storageProvider === 'IBM') {
                if (filespaceLineItem.subscriptionType === FilespaceLineItem.SubscriptionTypeEnum.Teams) {
                    return (<td className="hidden left">{planBasedStrings.LucidLinkTeams}</td>);
                } else if (filespaceLineItem.subscriptionType === FilespaceLineItem.SubscriptionTypeEnum.Enterprise) {
                    return (<td className="hidden left">{planBasedStrings.LucidLinkEnterprise}</td>);
                } else if (filespaceLineItem.subscriptionType === FilespaceLineItem.SubscriptionTypeEnum.Advanced) {
                    return (<td className="hidden left">{planBasedStrings.LucidLinkAdvanced}</td>);
                } else {
                    return (<td className="hidden left">LuicdLink Storage</td>);
                }
            } else {
                return (<td className="hidden left">LuicdLink Storage</td>);
            }
        }
    }

    protected renderUsage(usageDimension: FilespaceUsage.DimensionEnum, usage: number) {
        if ((usageDimension !== FilespaceUsage.DimensionEnum.Capacity &&
            usageDimension !== FilespaceUsage.DimensionEnum.ManagedCapacity) ||
            usage < 1) {
            return `${usage} ${this.getDescriptionUsageSuffix(usageDimension)}`;
        }
        return formatDataSize(usage * GIB_MULTIPLIER);
    }
}
export default FilespaceBreakdownBase;



// WEBPACK FOOTER //
// ./src/webportal/components/FilespaceBreakdownBase.tsx